import WithDirection from '@app/settings/withDirection';
import { Rate } from 'antd';
import Ratings from './styles/rating.style';

const AntRating = Ratings(Rate);

export const IsoRate = WithDirection(AntRating);
